export default "__VITE_ASSET__8517b2d7__"